import { Button, Input, makeStyles, Tab, TabView, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import React, { useState } from 'react'
import { Keyboard, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { ScrollView } from 'react-native-gesture-handler'
import { ApiInfo } from './types'

interface Props {
  onTest: (url: string) => Promise<any>
  index: number | undefined
  setIndex: React.Dispatch<React.SetStateAction<number>>
  apiList: ApiInfo[]
  setApiList: React.Dispatch<React.SetStateAction<ApiInfo[]>>
  onChangeText: (text: string) => void
}

export function DevToolsView({
  onTest,
  index,
  setIndex,
  apiList,
  setApiList,
  onChangeText,
}: Props) {
  const styles = useStyles()

  const [isLoading, setLoading] = useState<boolean>(false)

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.container}>
      <Text style={styles.title}>{t('apiEndpoint')}</Text>
      <Tab
        value={index}
        onChange={setIndex}
        indicatorStyle={styles.indicator}
        variant="primary"
      >
        {apiList.map((api, i) => (
          <Tab.Item
            title={api.envName}
            titleStyle={styles.tabItemTitle}
            key={String(i)}
          />
        ))}
      </Tab>

      <TabView
        value={index}
        onChange={setIndex}
        containerStyle={styles.tabsViewContainer}
        disableSwipe
      >
        {apiList.map((api, i) => (
          <TabView.Item style={styles.tabViewItemContainer} key={String(i)}>
            <View style={styles.tabViewItem}>
              <View style={styles.row}>
                <Input
                  value={api.endpoint}
                  containerStyle={styles.input}
                  editable={api.envName === 'custom'}
                  onChangeText={onChangeText}
                />
                <Button
                  title={t('test')}
                  onPress={async () => {
                    Keyboard.dismiss()
                    setLoading(true)
                    const res = await onTest(api.endpoint)
                    if (res) {
                      const newApiList = [...apiList]
                      newApiList[i] = { ...apiList[i], response: res }
                      setApiList(newApiList)
                    }
                    setLoading(false)
                  }}
                  loading={isLoading}
                  disabled={api.endpoint === ''}
                  size={'lg'}
                />
              </View>
              <ScrollView contentContainerStyle={styles.responseContainer}>
                <Text>{api.response}</Text>
              </ScrollView>
            </View>
          </TabView.Item>
        ))}
      </TabView>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors?.grey6,
  },
  title: {
    textAlign: 'center',
    fontSize: 18,
    marginVertical: 10,
  },
  indicator: {
    backgroundColor: 'white',
    height: 1,
  },
  tabItemTitle: {
    fontSize: 16,
    paddingHorizontal: 0,
  },
  tabsViewContainer: {
    padding: 20,
    flex: 1,
    alignItems: 'center',
  },
  tabViewItemContainer: {
    flex: 1,
  },
  tabViewItem: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    marginTop: 20,
    marginHorizontal: 10,
    justifyContent: 'space-between',
  },
  input: {
    flex: 1,
    paddingHorizontal: 5,
    paddingVertical: 10,
    borderWidth: 1,
    borderColor: theme.colors?.grey2,
    borderRadius: 5,
    color: theme.colors?.black,
    marginRight: 10,
  },
  responseContainer: {
    margin: 10,
    padding: 20,
  },
}))
